import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { useNavigate } from 'react-router-dom';
import useIntl from 'react-intl/src/components/useIntl';
import { ROUTES, buildHairDresserPath } from '@shared/AppRoutes';
import { PendingReservation } from '@features/pending-reservations/api';

const PRIMARY = '#D02964';

type PendingReservationsCardProps = {
  reservations: PendingReservation[];
};

const PendingReservationsCard = ({ reservations }: PendingReservationsCardProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const goToReservations = () => navigate(buildHairDresserPath(ROUTES.pendingReservations.path));

  return (
    <Stack direction="column" rowGap={1.5}>
      <Stack spacing={1}>
        {reservations.map(reservation => (
          <Box
            key={reservation.id}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              bgcolor: `${PRIMARY}0d`,
              border: '1px solid',
              borderColor: `${PRIMARY}33`,
              borderRadius: '10px',
              px: 1.5,
              py: 1,
            }}
          >
            <Typography variant="body2" fontWeight={700} color="text.primary" noWrap>
              {reservation.customerFirstName} {reservation.customerLastName}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {reservation.service.serviceName}
            </Typography>
          </Box>
        ))}
      </Stack>

      <Button
        variant="contained"
        fullWidth
        endIcon={<ArrowForwardRoundedIcon />}
        onClick={goToReservations}
        sx={{
          bgcolor: PRIMARY,
          borderRadius: '10px',
          fontWeight: 700,
          '&:hover': { bgcolor: '#b31f52' },
        }}
      >
        {intl.formatMessage({
          id: 'dashboard.pendingReservations.action',
          defaultMessage: 'Zobrazit žádosti o rezervaci',
        })}
      </Button>
    </Stack>
  );
};

export default PendingReservationsCard;
